// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1_LHc","dragIcon":"Choice_dragIcon__3N-wX","left":"Choice_left__1mdu9","input":"Choice_input__3EWXH"};